import _ from 'lodash';
import React from 'react';
import { memberInvitationStatuses } from '~/lookups';
import MultiSelect from '../MultiSelect';

const options = _.values(memberInvitationStatuses);

export default function MemberInvitationStatusFilter({
  placeholder = 'Member Invitation Status',
  name,
  value,
  onChange,
}) {
  return (
    <MultiSelect.Filter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.map((v) => v.name).join('; ')}
      options={options}
      onChange={onChange}
    />
  );
}
